<template>
<div class="chapter">
<div class="inner_page">
<h1 class="tocchaptitle"><a id="contents"></a><b>Contents</b></h1>
<p style="text-align:center; margin-top:3pc"></p>
<p class="toc1"><a href="#/05introduction#intro"><b><i>Introduction</i></b></a></p>
<p style="text-align:center; margin-top:3pc"></p>
<p class="toc1"><a href="#/06chapter01#c01-01">Rods (Skyfish)</a></p>
<p style="text-align:center; margin-top:0.5pc"></p>
<p class="toc1"><a href="#/06chapter01#c01-02">Mongolian Death Worms</a></p>
<p style="text-align:center; margin-top:0.5pc"></p>
<p class="toc1"><a href="#/06chapter01#c01-04">Ahool and Other Giant Bats</a></p>
<p style="text-align:center; margin-top:0.5pc"></p>
<p class="toc1"><a href="#/06chapter01#c01-06">Loogaroo Vampires of the West Indies</a></p>
<p style="text-align:center; margin-top:0.5pc"></p>
<p class="toc1"><a href="#/06chapter01#c01-08">Bunyips (Water Horses)</a></p>
<p style="text-align:center; margin-top:0.5pc"></p>
<p class="toc1"><a href="#/06chapter01#c01-10">Kentucky Goblins</a></p>
<p style="text-align:center; margin-top:0.5pc"></p>
<p class="toc1"><a href="#/06chapter01#c01-11">Tommyknockers of California</a></p>
<p style="text-align:center; margin-top:0.5pc"></p>
<p class="toc1"><a href="#/06chapter01#c01-13">Enfield Horror (Giant Kangaroos)</a></p>
<p style="text-align:center; margin-top:0.5pc"></p>
<p class="toc1"><a href="#/06chapter01#c01-15">Frogmen of Loveland</a></p>
<p style="text-align:center; margin-top:0.5pc"></p>
<p class="toc1"><a href="#/06chapter01#c01-17">Gray Man of Ben MacDhui</a></p>
<p style="text-align:center; margin-top:0.5pc"></p>
<p class="toc1"><a href="#/06chapter01#c01-19">Lusca and Other Giant Octopuses</a></p>
<p style="text-align:center; margin-top:0.5pc"></p>
<p class="toc1"><a href="#/06chapter01#c01-21">Flying Man of Falls City, Nebraska, and Other Flying Humanoids</a></p>
<p style="text-align:center; margin-top:0.5pc"></p>
<p class="toc1"><a href="#/06chapter01#c01-23">The Awful</a></p>
<p style="text-align:center; margin-top:0.5pc"></p>
<p class="toc1"><a href="#/06chapter01#c01-24">Beast of Busco (Giant Turtle)</a></p>
<p style="text-align:center; margin-top:0.5pc"></p>
<p class="toc1"><a href="#/06chapter01#c01-26">Giant Rabbits of England</a></p>
<p style="text-align:center; margin-top:0.5pc"></p>
<p class="toc1"><a href="#/06chapter01#c01-28">Thunderbirds (<i>Piasa</i>)</a></p>
<p style="text-align:center; margin-top:0.5pc"></p>
<p class="toc1"><a href="#/06chapter01#c01-30">Jake and Other Alligator Men</a></p>
<p style="text-align:center; margin-top:0.5pc"></p>
<p class="toc1"><a href="#/06chapter01#c01-32">Beast of Bray Road and Other Contemporary Werewolves</a></p>
<p style="text-align:center; margin-top:0.5pc"></p>
<p class="toc1"><a href="#/06chapter01#c01-34">Goatman</a></p>
<p style="text-align:center; margin-top:0.5pc"></p>
<p class="toc1"><a href="#/06chapter01#c01-35">Giant Catfish</a></p>
<p style="text-align:center; margin-top:0.5pc"></p>
<p class="toc1"><a href="#/06chapter01#c01-36">Moas (Giant Flightless Birds)</a></p>
<p style="text-align:center; margin-top:0.5pc"></p>
<p class="toc1"><a href="#/06chapter01#c01-38">Shadow People</a></p>
<p style="text-align:center; margin-top:0.5pc"></p>
<p class="toc1"><a href="#/06chapter01#c01-39">Black Dogs</a></p>
<p style="text-align:center; margin-top:0.5pc"></p>
<p class="toc1"><a href="#/06chapter01#c01-40">Kappa (Japanese River Imps)</a></p>
<p style="text-align:center; margin-top:0.5pc"></p>
<p class="toc1"><a href="#/06chapter01#c01-42"><i>Encantados</i> (Dolphin-Men of Brazil)</a></p>
<p style="text-align:center; margin-top:0.5pc"></p>
<p class="toc1"><a href="#/06chapter01#c01-44"><i>Clurichauns</i></a></p>
<p style="text-align:center; margin-top:0.5pc"></p>
<p class="toc1"><a href="#/06chapter01#c01-45">Giant Spiders</a></p>
<p style="text-align:center; margin-top:0.5pc"></p>
<p class="toc1"><a href="#/06chapter01#c01-46">Boston Lemur</a></p>
<p style="text-align:center; margin-top:0.5pc"></p>
<p class="toc1"><a href="#/06chapter01#c01-47">Dragons</a></p>
<p style="text-align:center; margin-top:0.5pc"></p>
<p class="toc1"><a href="#/06chapter01#c01-48">Spring Heeled Jack</a></p>
<p style="text-align:center; margin-top:0.5pc"></p>
<p class="toc1"><a href="#/06chapter01#c01-50">Beast of Bladenboro, North Carolina</a></p>
<p style="text-align:center; margin-top:0.5pc"></p>
<p class="toc1"><a href="#/06chapter01#c01-52">Ohio Grassman</a></p>
<p style="text-align:center; margin-top:0.5pc"></p>
<p class="toc1"><a href="#/06chapter01#c01-53">Lizard Man of Scape Ore, South Carolina</a></p>
<p style="text-align:center; margin-top:0.5pc"></p>
<p class="toc1"><a href="#/06chapter01#c01-55">Lobo (Wolf) Girl of Texas</a></p>
<p style="text-align:center; margin-top:0.5pc"></p>
<p class="toc1"><a href="#/06chapter01#c01-57">Giant Rats of New York City</a></p>
<p style="text-align:center; margin-top:0.5pc"></p>
<p class="toc1"><a href="#/06chapter01#c01-59">Dover Demon</a></p>
<p style="text-align:center; margin-top:0.5pc"></p>
<p class="toc1"><a href="#/06chapter01#c01-60">Mothman of West Virginia</a></p>
<p style="text-align:center; margin-top:0.5pc"></p>
<p class="toc1"><a href="#/06chapter01#c01-62">New Jersey Devil</a></p>
<p style="text-align:center; margin-top:0.5pc"></p>
<p class="toc1"><a href="#/06chapter01#c01-63"><i>Chupacabra</i></a></p>
<p style="text-align:center; margin-top:0.5pc"></p>
<p class="toc1"><a href="#/06chapter01#c01-64">A Tale of MoMo (Missouri Monster)</a></p>
<p style="text-align:center; margin-top:3pc"></p>
<p class="toc1"><a href="#/07furtherreading#further"><b><i>Further Reading</i></b></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04-content.vue?04ed3248